import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export const PageLoader = () => {
	return (
		<Box
			data-component="page-loader"
			sx={{
				display: "flex",
				position: "absolute",
				top: 0,
				bottom: 0,
				// `left: 0` is what keeps the loader on screen. Without it an
				// absolutely positioned box keeps its STATIC position, so inside
				// a padded page (`<Box sx={{ p: 2 }}>` on /charts/llm_performance)
				// it starts 16px in while `width: 100%` still resolves against the
				// 390px containing block — the document ends at 406px and the
				// phone sweep rightly reports "16px wider than the screen".
				left: 0,
				height: "100vh",
				width: "100%",
				alignItems: "center",
				justifyContent: "center",
				zIndex: -1,
			}}
		>
			<CircularProgress size="10rem" />
		</Box>
	);
};
